import { render, staticRenderFns } from "./selectRect.vue?vue&type=template&id=38cee383&scoped=true&"
import script from "./selectRect.vue?vue&type=script&lang=js&"
export * from "./selectRect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cee383",
  null
  
)

export default component.exports